export default __webpack_public_path__ + "static/media/Boots of the Tormentor.111df264.jpg";